export default "__VITE_ASSET__BBdzalpD__"